export const config = {
  rowSelectionType: 'radio',
  fieldControl: false,
  columns: [
    {
      title: '商机ID',
      dataIndex: 'id',
      width: 180,
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 120,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '需求标签',
      dataIndex: 'bizTypeName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
  ],
  search: [
    {
      name: 'nameLike',
      label: '客户姓名',
    },
    {
      name: 'phone',
      label: '客户电话',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'trackPlanId',
      label: '商机ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
  ],
}
